// import {
//   DIALOG_ERROR_OPEN,
//   DIALOG_ERROR_CLOSE,
//   DIALOG_LOGIN_OPEN,
//   DIALOG_LOGIN_CLOSE,
//   DIALOG_REGISTER_OPEN,
//   DIALOG_REGISTER_CLOSE,
// } from "./dialogTypes";
const DIALOG_ERROR_OPEN = "DIALOG_ERROR_OPEN";
const DIALOG_ERROR_CLOSE = "DIALOG_ERROR_CLOSE";
const DIALOG_LOGIN_OPEN = "DIALOG_LOGIN_OPEN";
const DIALOG_LOGIN_CLOSE = "DIALOG_LOGIN_CLOSE";
const DIALOG_REGISTER_OPEN = "DIALOG_REGISTER_OPEN";
const DIALOG_REGISTER_CLOSE = "DIALOG_REGISTER_CLOSE";

const initial_state = {
  dialogErrorOpen: false,
  dialogErrorMessage: "",
  dialogLoginOpen: false,
  dialogLoginMessage: "",
  dialogRegisterOpen: false,
  dialogRegisterMessage: "",
};

// const errorDialogReducer = new Reducer((state = initial_state), (action) => {
//   switch (action.type) {
//     case TOGGLE_DIALOG:
//       return {
//         ...state,
//         dialogErrorOpen: !dialogErrorOpen,
//       };
//     default:
//       return state;
//   }
// });
const dialogReducer = (state = initial_state, action) => {
  switch (action.type) {
    case DIALOG_ERROR_OPEN:
      return {
        ...state,
        dialogErrorOpen: true,
        dialogErrorMessage: action.payload,
      };
    case DIALOG_ERROR_CLOSE:
      return {
        ...state,
        dialogErrorOpen: false,
        dialogErrorMessage: action.payload,
      };
    case DIALOG_LOGIN_OPEN:
      return {
        ...state,
        dialogLoginOpen: true,
        dialogLoginMessage: action.payload,
      };
    case DIALOG_LOGIN_CLOSE:
      return {
        ...state,
        dialogLoginOpen: false,
        dialogLoginMessage: action.payload,
      };
    case DIALOG_REGISTER_OPEN:
      return {
        ...state,
        dialogRegisterOpen: true,
        dialogRegisterMessage: action.payload,
      };
    case DIALOG_REGISTER_CLOSE:
      return {
        ...state,
        dialogRegisterOpen: false,
        dialogRegisterMessage: action.payload,
      };
    default:
      return state;
  }
};

export default dialogReducer;
